import { render } from "./ServiceCardContainer.vue?vue&type=template&id=130d43bb&scoped=true&ts=true"
import script from "./ServiceCardContainer.vue?vue&type=script&lang=ts"
export * from "./ServiceCardContainer.vue?vue&type=script&lang=ts"

import "./ServiceCardContainer.vue?vue&type=style&index=0&id=130d43bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130d43bb"]])

export default __exports__